import * as React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { useKeycloak } from '@project/auth/keycloakInstance';

interface ProtectedRouteProps {
  requiredRoles?: string[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requiredRoles }) => {
  const { keycloak } = useKeycloak();
  const location = useLocation();

  // 1. Check Authentication
  if (!keycloak.authenticated) {
    // Redirect to login if not authenticated
    // Use 'state' to remember the current location for redirect after login
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // 2. Check Roles (Authorization)
  if (requiredRoles && requiredRoles.length > 0) {
    const hasRequiredRole = requiredRoles.some((role) => 
      keycloak.hasRealmRole(role) || keycloak.hasResourceRole(role)
    );

    if (!hasRequiredRole) {
      // Redirect to an unauthorized page or home if the role is missing
      return <Navigate to="/unauthorized" replace />;
    }
  }

  // 3. Authorized: Render the nested child routes
  return <Outlet />;
};